import React from 'react';

import { getValueFromDictBy } from 'helpers/fieldsHelpers';

const getEducationFromDict = getValueFromDictBy('id', 'value');

const getEducationString = ({ comment, level }, dictionary) => {
    const education = level && getEducationFromDict(level, dictionary, '');
    return comment ? `${education} (${comment})` : education;
};

const RequestEducation = ({ education, options }) => education && options ? (
    <span>{getEducationString(education, options)}</span>
) : null;

export default RequestEducation;
